export default "__VITE_ASSET__CFtKftHw__"